import React, { useState, useEffect } from "react";
import { Button, Form, Icon } from "tabler-react";
import { Crud_Catalogos } from "../../herramientas/Crud_Catalogos";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import "./RemolquesForm.css";

const RemolquesForm = ({
  accion,
  elementos,
  cerrarModal,
  idTransportista: idTransportistaProp,
  onSave
}) => {
  const [formulario, setFormulario] = useState({
    placa: "",
    economico: "",
    tipoRemolque: null
  });

  const [tiposRemolqueOpciones, setTiposRemolqueOpciones] = useState([]);
  const [crudbutonEnable, setCrudbutonEnable] = useState(true);
  const [idTransportista, setIdTransportista] = useState(null);

  useEffect(() => {
    // Obtener idTransportista
    if (idTransportistaProp) {
      setIdTransportista(idTransportistaProp);
    } else {
      const usuario = JSON.parse(sessionStorage.getItem("usuario"));
      const plataforma = JSON.parse(sessionStorage.getItem("plataforma"));
      if (usuario && plataforma) {
        Crud_Catalogos(
          "usuarios_transportistas/usuario/" + usuario.id + "/plataforma/" + plataforma.id,
          "", "get", "", [], "", "", "", []
        ).then((transportistas) => {
          if (transportistas && transportistas.length > 0) {
            const transportistaValido = transportistas.find(t => t.idTransportista !== null);
            if (transportistaValido) {
              setIdTransportista(transportistaValido.idTransportista);
            }
          }
        }).catch(err => console.error("Error al cargar transportista:", err));
      }
    }

    // Cargar tipos de remolques
    Crud_Catalogos("remolquesTipo", "", "get", "", [], "", "", "", []).then((returnVal) => {
      if (returnVal && Array.isArray(returnVal)) {
        let remolquesTemp = [{ label: "Selecciona una opción", value: "" }];
        returnVal.forEach(remolque => {
          remolquesTemp.push({ value: remolque.idRemolque, label: remolque.nombre });
        });
        setTiposRemolqueOpciones(remolquesTemp);
      }
    });

    // Si es edición, cargar datos
    if (accion === "editar" && elementos) {
      setFormulario({
        placa: elementos.placa || "",
        economico: elementos.economico || "",
        tipoRemolque: elementos.remolquesTipos
          ? { value: elementos.remolquesTipos.idRemolque, label: elementos.remolquesTipos.nombre }
          : null
      });
    }

    // Si es nuevo pero se pasan elementos (vinculación desde histórico), pre-llenar
    if (accion === "nuevo" && elementos) {
      setFormulario(prev => ({
        ...prev,
        placa: elementos.placa || "",
        economico: elementos.economico || "",
        tipoRemolque: elementos.remolquesTipos
          ? { value: elementos.remolquesTipos.idRemolque, label: elementos.remolquesTipos.nombre }
          : null
      }));
    }
  }, []);

  // Función para vincular un remolque existente al transportista actual
  const vincularRemolqueExistente = async (placa, idTransp) => {
    try {
      // Buscar el remolque por placa en todos los remolques
      const todosRemolques = await Crud_Catalogos("remolques", "", "get", "", [], "", "", "", []);
      if (!todosRemolques || !Array.isArray(todosRemolques)) {
        NotificationManager.error("Error al buscar remolques existentes", "Error");
        setCrudbutonEnable(true);
        return;
      }

      const remolqueExistente = todosRemolques.find(
        r => r.placa?.toUpperCase().trim() === placa.toUpperCase().trim()
      );

      if (!remolqueExistente) {
        NotificationManager.error("Error al guardar el remolque", "Error");
        setCrudbutonEnable(true);
        return;
      }

      // Verificar si ya tiene relación con este transportista
      const relaciones = await Crud_Catalogos(
        "remolques_transportistas/id_transportista/" + idTransp,
        "", "get", "", [], "", "", "", []
      );

      if (Array.isArray(relaciones)) {
        const relacionActiva = relaciones.find(
          r => r.idRemolque === remolqueExistente.idRemolque && r.estatus !== false
        );

        if (relacionActiva) {
          NotificationManager.info("Este remolque ya existe en tu catálogo", "Remolque existente");
          if (onSave) {
            onSave({
              idRemolque: remolqueExistente.idRemolque,
              placa: remolqueExistente.placa,
              economico: remolqueExistente.economico,
              remolquesTipos: remolqueExistente.remolquesTipos,
            });
          }
          cerrarModal();
          return;
        }

        // Verificar si tiene relación desactivada (para reactivar)
        const relacionDesactivada = relaciones.find(
          r => r.idRemolque === remolqueExistente.idRemolque && r.estatus === false
        );

        if (relacionDesactivada) {
          const reactivado = await Crud_Catalogos(
            "remolques_transportistas/activar/" + remolqueExistente.idRemolque + "/" + idTransp,
            "", "put", "", {}, "", "", "", []
          );
          if (reactivado !== false) {
            NotificationManager.success("Remolque vinculado exitosamente a tu catálogo", "Éxito");
            if (onSave) {
              onSave({
                idRemolque: remolqueExistente.idRemolque,
                placa: remolqueExistente.placa,
                economico: remolqueExistente.economico,
                remolquesTipos: remolqueExistente.remolquesTipos,
              });
            }
            cerrarModal();
            return;
          }
        }
      }

      // No tiene relación → crear nueva
      const nuevaRelacion = await Crud_Catalogos("remolques_transportistas", "", "post", "", {
        idRemolque: remolqueExistente.idRemolque,
        idTransportista: idTransp
      }, "", "", "", []);

      if (nuevaRelacion !== false) {
        NotificationManager.success("Remolque vinculado exitosamente a tu catálogo", "Éxito");
        if (onSave) {
          onSave({
            idRemolque: remolqueExistente.idRemolque,
            placa: remolqueExistente.placa,
            economico: remolqueExistente.economico,
            remolquesTipos: remolqueExistente.remolquesTipos,
          });
        }
        cerrarModal();
      } else {
        NotificationManager.error("Error al vincular el remolque", "Error");
        setCrudbutonEnable(true);
      }
    } catch (error) {
      console.error("Error al vincular remolque existente:", error);
      NotificationManager.error("Error al vincular el remolque", "Error");
      setCrudbutonEnable(true);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    setCrudbutonEnable(false);

    // Si es vinculación (nuevo con elementos pre-llenados), intentar vincular por placa primero
    if (accion === "nuevo" && elementos && formulario.placa && (idTransportista || idTransportistaProp)) {
      try {
        const todosRemolques = await Crud_Catalogos("remolques", "", "get", "", [], "", "", "", []);
        if (todosRemolques && Array.isArray(todosRemolques)) {
          const remolqueExistente = todosRemolques.find(
            r => r.placa?.toUpperCase().trim() === formulario.placa.trim().toUpperCase()
          );
          if (remolqueExistente) {
            // Ya existe en el catálogo global, vincular al transportista
            await vincularRemolqueExistente(formulario.placa.trim().toUpperCase(), idTransportista || idTransportistaProp);
            return;
          }
        }
      } catch (err) {
        console.error("Error buscando remolque existente para vincular:", err);
        // Si falla la búsqueda, continuar con el flujo normal de creación
      }
    }

    const remolqueDTO = {
      placa: (formulario.placa || "").trim().toUpperCase(),
      economico: (formulario.economico || "").trim(),
      idTransportista: idTransportista || idTransportistaProp,
      remolquesTipos: formulario.tipoRemolque?.value
        ? { idRemolque: formulario.tipoRemolque.value }
        : null
    };

    if (accion === "editar") {
      // Editar remolque existente - usar la misma estructura que funciona en Clientes
      const remolqueUpdate = {
        placa: remolqueDTO.placa,
        economico: remolqueDTO.economico,
        idTransportista: idTransportista || idTransportistaProp,
        remolquesTipos: {
          idRemolque: formulario.tipoRemolque?.value || elementos.remolquesTipos?.idRemolque
        }
      };

      const resultado = await Crud_Catalogos(
        `remolques/${elementos.idRemolque}`, "", "put", "", remolqueUpdate, "", "", "", []
      );

      if (resultado !== false && resultado !== undefined) {
        NotificationManager.success("Remolque actualizado exitosamente", "Éxito");
        if (onSave) {
          onSave({
            idRemolque: elementos.idRemolque,
            placa: remolqueDTO.placa,
            economico: remolqueDTO.economico,
            remolquesTipos: formulario.tipoRemolque
              ? { idRemolque: formulario.tipoRemolque.value, nombre: formulario.tipoRemolque.label }
              : null,
          });
        }
        cerrarModal();
      } else {
        NotificationManager.error("Error al actualizar el remolque", "Error");
        setCrudbutonEnable(true);
      }
    } else {
      // Crear nuevo remolque
      const response = await Crud_Catalogos("remolques", "", "post", "", remolqueDTO, "", "", "", []);

      if (response !== false && response && response.idRemolque) {
        // Crear relación con transportista
        const idTransp = idTransportista || idTransportistaProp;
        if (idTransp) {
          const relacion = await Crud_Catalogos("remolques_transportistas", "", "post", "", {
            idRemolque: response.idRemolque,
            idTransportista: idTransp
          }, "", "", "", []);

          if (relacion === false) {
            NotificationManager.warning(
              "Remolque creado pero no se pudo asignar al transportista",
              "Advertencia"
            );
          } else {
            NotificationManager.success("Remolque creado exitosamente", "Éxito");
          }
        } else {
          NotificationManager.success("Remolque creado exitosamente", "Éxito");
        }

        if (onSave) {
          onSave({
            idRemolque: response.idRemolque,
            placa: remolqueDTO.placa,
            economico: remolqueDTO.economico,
            remolquesTipos: formulario.tipoRemolque
              ? { idRemolque: formulario.tipoRemolque.value, nombre: formulario.tipoRemolque.label }
              : null,
          });
        }
        cerrarModal();
      } else {
        // Posible duplicado → intentar vincular remolque existente
        const idTransp = idTransportista || idTransportistaProp;
        if (idTransp && remolqueDTO.placa) {
          vincularRemolqueExistente(remolqueDTO.placa, idTransp);
        } else {
          NotificationManager.error("Error al guardar el remolque", "Error");
          setCrudbutonEnable(true);
        }
      }
    }
  };

  return (
    <div className="remolque-form-container">
      <div className="remolque-header">
        <Icon name="package" className="header-icon" />
        <h2>{accion === "nuevo" ? "Nuevo Remolque" : "Editar Remolque"}</h2>
      </div>

      <Form onSubmit={handleSubmit} className="remolque-form">
        <div className="form-section">
          <div className="form-field">
            <label className="field-label">
              <Icon name={accion === "editar" ? "lock" : "hash"} />
              Placa {accion === "editar" && (
                <span style={{ fontSize: "11px", color: "#888", marginLeft: "4px" }}>
                  (no modificable)
                </span>
              )}
            </label>
            <Form.Input
              name="placa"
              required
              value={formulario.placa}
              readOnly={accion === "editar"}
              onChange={(e) =>
                accion !== "editar" &&
                setFormulario({ ...formulario, placa: e.target.value.toUpperCase() })
              }
              placeholder="Ej: ABC123"
              style={accion === "editar" ? { backgroundColor: "#f0f0f0", cursor: "not-allowed" } : {}}
            />
          </div>

          <div className="form-field">
            <label className="field-label">
              <Icon name="tag" />
              Económico
            </label>
            <Form.Input
              name="economico"
              required
              value={formulario.economico}
              onChange={(e) => setFormulario({ ...formulario, economico: e.target.value })}
              placeholder="Ej: REM-001"
            />
          </div>

          <div className="form-field">
            <label className="field-label">
              <Icon name="package" />
              Tipo de Remolque
            </label>
            <Select
              name="tipoRemolque"
              value={formulario.tipoRemolque}
              onChange={(val) => setFormulario(prev => ({ ...prev, tipoRemolque: val }))}
              options={tiposRemolqueOpciones}
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 100001 }) }}
              placeholder="Selecciona una opción"
            />
          </div>
        </div>

        <div className="form-actions">
          <Button type="submit" color="primary" disabled={!crudbutonEnable}>
            <Icon name="save" />
            {accion === "nuevo" ? " Guardar" : " Actualizar"}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default RemolquesForm;
